import { newrelic } from '../newrelic/newrelic';
import { FeedbackMode as Mode } from './use-feedback';

export const trackRating = ({
  feedbackMode,
  panelContext,
  question,
  ratingValue,
}: {
  panelContext: string;
  feedbackMode: Mode;
  question: string;
  ratingValue: number;
}) =>
  newrelic.addPageAction('feedback', {
    context: panelContext,
    triggerType: 'icon',
    triggerName: feedbackMode === Mode.Scale ? 'star' : 'thumb',
    triggerAction: 'click',
    value: ratingValue,
    question,
  });

export const trackResetFeedback = (panelContext: string) =>
  newrelic.addPageAction('feedback', {
    context: panelContext,
    triggerType: 'button',
    triggerName: 'close',
    triggerAction: 'click',
  });

export const trackFeedbackSubmission = ({
  panelContext,
  question,
  rating,
  content,
}: {
  panelContext: string;
  question: string;
  content: string;
  rating: number;
}) =>
  newrelic.addPageAction('feedback', {
    context: panelContext,
    triggerType: 'button',
    triggerName: 'submit',
    triggerAction: 'click',
    value: content,
    rating,
    question,
  });

export const trackClickFeedback = (bannerContext: string) =>
  newrelic.addPageAction('feedback', {
    context: bannerContext,
    triggerType: 'button',
    triggerName: 'open',
    triggerAction: 'click',
  });
